import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const OrderManagement = () => {
  const [activeTab, setActiveTab] = useState('전체');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [showVendorSelect, setShowVendorSelect] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [vendorSearchTerm, setVendorSearchTerm] = useState('');
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPaymentOrder, setSelectedPaymentOrder] = useState<any>(null);
  const [ordersList, setOrdersList] = useState([
    {
      id: 'ORD-001',
      customer: '김민수',
      phone: '010-1234-5678',
      weddingDate: '2024-03-15',
      venue: '그랜드볼룸',
      vendor: '스튜디오 블루',
      manager: '이영희',
      service: '스튜디오',
      amount: '1,500,000원',
      paidAmount: '1,500,000원',
      commission: '15%',
      status: '거래완료',
      progress: 100,
      orderDate: '2024-01-15',
      invoiceNumber: 'INV-2024-001',
      taxInvoiceNumber: 'TAX-2024-001',
      notes: '고객 요청사항: 야외촬영 포함',
      files: ['계약서.pdf', '촬영컨셉.jpg']
    },
    {
      id: 'ORD-002',
      customer: '박지영',
      phone: '010-2345-6789',
      weddingDate: '2024-04-20',
      venue: '로얄팰리스',
      vendor: '드레스샵 엘레강스',
      manager: '최수진',
      service: '드레스',
      amount: '800,000원',
      paidAmount: '800,000원',
      commission: '12%',
      status: '세금계산서',
      progress: 83,
      orderDate: '2024-01-20',
      invoiceNumber: 'INV-2024-002',
      taxInvoiceNumber: '',
      notes: '',
      files: ['드레스사진.jpg']
    },
    {
      id: 'ORD-003',
      customer: '정현우',
      phone: '010-3456-7890',
      weddingDate: '2024-05-10',
      venue: '시그니엘',
      vendor: '메이크업 아티스트',
      manager: '김소영',
      service: '메이크업',
      amount: '600,000원',
      paidAmount: '0원',
      commission: '10%',
      status: '인보이스',
      progress: 50,
      orderDate: '2024-02-01',
      invoiceNumber: 'INV-2024-003',
      taxInvoiceNumber: '',
      notes: '리허설 메이크업 포함',
      files: []
    },
    {
      id: 'ORD-004',
      customer: '이서연',
      phone: '010-4567-8901',
      weddingDate: '2024-06-05',
      venue: '웨딩홀 라벤더',
      vendor: '예복 전문점',
      manager: '박민호',
      service: '예복',
      amount: '400,000원',
      paidAmount: '0원',
      commission: '8%',
      status: '역발주',
      progress: 33,
      orderDate: '2024-02-10',
      invoiceNumber: '',
      taxInvoiceNumber: '',
      notes: '',
      files: []
    },
    {
      id: 'ORD-005',
      customer: '강태현',
      phone: '010-5678-9012',
      weddingDate: '2024-07-15',
      venue: '가든파티',
      vendor: '스튜디오 화이트',
      manager: '윤지혜',
      service: '스튜디오',
      amount: '2,000,000원',
      paidAmount: '0원',
      commission: '15%',
      status: '발주서',
      progress: 17,
      orderDate: '2024-02-15',
      invoiceNumber: '',
      taxInvoiceNumber: '',
      notes: '해외촬영 희망',
      files: []
    }
  ]);

  const handleEditClick = (order: any) => {
    setSelectedOrder(order);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    // 저장 로직
    setEditModalOpen(false);
    setSelectedOrder(null);
  };

  const handlePaymentComplete = (order: any) => {
    setSelectedPaymentOrder(order);
    setPaymentModalOpen(true);
  };

  const handleConfirmPayment = () => {
    if (selectedPaymentOrder) {
      const updatedOrders = ordersList.map(order => {
        if (order.id === selectedPaymentOrder.id) {
          return {
            ...order,
            status: '결제',
            progress: 67,
            paidAmount: order.amount
          };
        }
        return order;
      });
      setOrdersList(updatedOrders);
      setPaymentModalOpen(false);
      setSelectedPaymentOrder(null);
    }
  };

  const orders = [
    {
      id: 'ORD-001',
      customer: '김민수',
      phone: '010-1234-5678',
      weddingDate: '2024-03-15',
      venue: '그랜드볼룸',
      vendor: '스튜디오 블루',
      manager: '이영희',
      service: '스튜디오',
      amount: '1,500,000원',
      paidAmount: '1,500,000원',
      commission: '15%',
      status: '거래완료',
      progress: 100,
      orderDate: '2024-01-15',
      invoiceNumber: 'INV-2024-001',
      taxInvoiceNumber: 'TAX-2024-001',
      notes: '고객 요청사항: 야외촬영 포함',
      files: ['계약서.pdf', '촬영컨셉.jpg']
    },
    {
      id: 'ORD-002',
      customer: '박지영',
      phone: '010-2345-6789',
      weddingDate: '2024-04-20',
      venue: '로얄팰리스',
      vendor: '드레스샵 엘레강스',
      manager: '최수진',
      service: '드레스',
      amount: '800,000원',
      paidAmount: '800,000원',
      commission: '12%',
      status: '세금계산서',
      progress: 83,
      orderDate: '2024-01-20',
      invoiceNumber: 'INV-2024-002',
      taxInvoiceNumber: '',
      notes: '',
      files: ['드레스사진.jpg']
    },
    {
      id: 'ORD-003',
      customer: '정현우',
      phone: '010-3456-7890',
      weddingDate: '2024-05-10',
      venue: '시그니엘',
      vendor: '메이크업 아티스트',
      manager: '김소영',
      service: '메이크업',
      amount: '600,000원',
      paidAmount: '0원',
      commission: '10%',
      status: '인보이스',
      progress: 50,
      orderDate: '2024-02-01',
      invoiceNumber: 'INV-2024-003',
      taxInvoiceNumber: '',
      notes: '리허설 메이크업 포함',
      files: []
    },
    {
      id: 'ORD-004',
      customer: '이서연',
      phone: '010-4567-8901',
      weddingDate: '2024-06-05',
      venue: '웨딩홀 라벤더',
      vendor: '예복 전문점',
      manager: '박민호',
      service: '예복',
      amount: '400,000원',
      paidAmount: '0원',
      commission: '8%',
      status: '역발주',
      progress: 33,
      orderDate: '2024-02-10',
      invoiceNumber: '',
      taxInvoiceNumber: '',
      notes: '',
      files: []
    },
    {
      id: 'ORD-005',
      customer: '강태현',
      phone: '010-5678-9012',
      weddingDate: '2024-07-15',
      venue: '가든파티',
      vendor: '스튜디오 화이트',
      manager: '윤지혜',
      service: '스튜디오',
      amount: '2,000,000원',
      paidAmount: '0원',
      commission: '15%',
      status: '발주서',
      progress: 17,
      orderDate: '2024-02-15',
      invoiceNumber: '',
      taxInvoiceNumber: '',
      notes: '해외촬영 희망',
      files: []
    }
  ];

  const tabs = ['전체', '발주서', '역발주', '인보이스', '결제', '세금계산서'];

  const getStatusColor = (status: string) => {
    switch (status) {
      case '거래완료': return 'bg-green-100 text-green-800';
      case '세금계산서': return 'bg-blue-100 text-blue-800';
      case '결제': return 'bg-purple-100 text-purple-800';
      case '인보이스': return 'bg-orange-100 text-orange-800';
      case '역발주': return 'bg-yellow-100 text-yellow-800';
      case '발주서': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const filteredOrders = activeTab === '전체' 
    ? orders 
    : orders.filter(order => order.status === activeTab);

  const totalAmount = orders.reduce((sum, order) => sum + parseInt(order.amount.replace(/[^0-9]/g, '')), 0);
  const paidAmount = orders.reduce((sum, order) => sum + parseInt(order?.paidAmount?.replace(/[^0-9]/g, '')), 0);

  // 고객 목록 데이터
  const customers = [
    {
      id: '1',
      name: '김미영',
      contact: '010-1234-5678',
      weddingDate: '2024-03-15',
      venue: '그랜드볼룸',
      manager: '김플래너'
    },
    {
      id: '2',
      name: '박지영',
      contact: '010-2345-6789',
      weddingDate: '2024-04-20',
      venue: '로얄팰리스',
      manager: '이플래너'
    },
    {
      id: '3',
      name: '정현우',
      contact: '010-3456-7890',
      weddingDate: '2024-05-10',
      venue: '시그니엘',
      manager: '김플래너'
    },
    {
      id: '4',
      name: '이서연',
      contact: '010-4567-8901',
      weddingDate: '2024-06-05',
      venue: '웨딩홀 라벤더',
      manager: '박플래너'
    },
    {
      id: '5',
      name: '강태현',
      contact: '010-5678-9012',
      weddingDate: '2024-07-15',
      venue: '가든파티',
      manager: '윤플래너'
    }
  ];

  // 등록된 업체 목록
  const registeredVendors = [
    {
      vendorIdx: '1',
      name: '스튜디오 블루',
      category: '웨딩업체',
      subCategory: '스튜디오',
      contact: '02-1234-5678',
      manager: '김스튜디오',
      email: 'blue@studio.co.kr',
      commissionRate: 15
    },
    {
      vendorIdx: '2',
      name: '드레스샵 엘레강스',
      category: '웨딩업체',
      subCategory: '드레스',
      contact: '02-2345-6789',
      manager: '박드레스',
      email: 'elegance@dress.co.kr',
      commissionRate: 12
    },
    {
      vendorIdx: '3',
      name: '메이크업 아티스트',
      category: '웨딩업체',
      subCategory: '메이크업',
      contact: '02-3456-7890',
      manager: '이뷰티',
      email: 'artist@makeup.co.kr',
      commissionRate: 10
    },
    {
      vendorIdx: '4',
      name: '예복 전문점',
      category: '웨딩업체',
      subCategory: '예복',
      contact: '02-4567-8901',
      manager: '최예복',
      email: 'hanbok@shop.co.kr',
      commissionRate: 8
    },
    {
      vendorIdx: '5',
      name: '스튜디오 화이트',
      category: '웨딩업체',
      subCategory: '스튜디오',
      contact: '02-5678-9012',
      manager: '정스튜디오',
      email: 'white@studio.co.kr',
      commissionRate: 15
    }
  ];

  const handleCustomerSelect = (customer: any) => {
    setSelectedCustomer(customer);
    setShowCustomerSelect(false);
  };

  const handleVendorSelect = (vendor: any) => {
    setSelectedVendor(vendor);
    setShowVendorSelect(false);
  };

  // 고객 검색 필터링
  const filteredCustomers = customers.filter(customer => 
    customer.name.toLowerCase().includes(customerSearchTerm.toLowerCase()) ||
    customer.contact.includes(customerSearchTerm)
  );

  // 업체 검색 필터링
  const filteredVendors = registeredVendors.filter(vendor =>
    vendor.name.toLowerCase().includes(vendorSearchTerm.toLowerCase()) ||
    vendor.subCategory.toLowerCase().includes(vendorSearchTerm.toLowerCase()) ||
    vendor.manager.toLowerCase().includes(vendorSearchTerm.toLowerCase())
  );

  return (
    <div className="flex h-screen  bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 p-8">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">발주 관리</h1>
            <p className="text-gray-600">스드메 업체와의 발주-결제-정산 프로세스를 관리합니다</p>
          </div>
          <button
            onClick={() => setAddModalOpen(true)}
            className="bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-add-line"></i>
            발주서 작성
          </button>
        </div>

        {/* 통계 카드 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">총 발주건수</p>
                <p className="text-2xl font-bold text-gray-900">{orders.length}건</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-file-list-3-line text-blue-600 text-xl"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">총 계약금액</p>
                <p className="text-2xl font-bold text-gray-900">{totalAmount.toLocaleString()}원</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-money-dollar-circle-line text-green-600 text-xl"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">결제완료</p>
                <p className="text-2xl font-bold text-green-600">{paidAmount.toLocaleString()}원</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-check-double-line text-green-600 text-xl"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">미결제</p>
                <p className="text-2xl font-bold text-red-600">{(totalAmount - paidAmount).toLocaleString()}원</p>
              </div>
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                <i className="ri-time-line text-red-600 text-xl"></i>
              </div>
            </div>
          </div>
        </div>

        {/* 탭 메뉴 */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === tab
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                {tab}
                <span className="ml-2 px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded-full">
                  {tab === '전체' ? orders.length : orders.filter(order => order.status === tab).length}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* 발주 목록 */}
        <div className="space-y-4">
          {filteredOrders.map((order) => (
            <div key={order.id} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              {/* 발주 헤더 */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className="ri-file-text-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{order.id}</h3>
                    <p className="text-sm text-gray-600">{order.customer} · {order.service}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(order.status)}`}>
                    {order.status}
                  </span>
                  {(order.status === '인보이스' || order.status === '역발주') && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePaymentComplete(order);
                      }}
                      className="bg-green-600 text-white px-4 py-1.5 rounded-full text-sm font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-check-line mr-1"></i>
                      결제완료
                    </button>
                  )}
                </div>
              </div>

              {/* 진행률 */}
              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-gray-600">진행률</span>
                  <span className="text-sm font-medium text-gray-900">{order.progress}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${order.progress}%` }}
                  ></div>
                </div>
              </div>

              {/* 발주 정보 */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <div>
                  <p className="text-xs text-gray-500 mb-1">업체명</p>
                  <p className="text-sm font-medium text-gray-900">{order.vendor}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">담당자</p>
                  <p className="text-sm font-medium text-gray-900">{order.managerName}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">계약금액</p>
                  <p className="text-sm font-medium text-gray-900">{order.amount}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">본식일</p>
                  <p className="text-sm font-medium text-gray-900">{order.weddingDate}</p>
                </div>
              </div>

              {/* 첨부파일 */}
              {order.files && order.files.length > 0 && (
                <div className="mb-4">
                  <p className="text-xs text-gray-500 mb-2">첨부파일</p>
                  <div className="flex flex-wrap gap-2">
                    {order.files.map((file, index) => (
                      <div key={index} className="flex items-center gap-2 bg-gray-50 px-3 py-1 rounded-lg">
                        <i className="ri-file-line text-gray-400"></i>
                        <span className="text-sm text-gray-700">{file}</span>
                        <button className="text-blue-600 hover:text-blue-800">
                          <i className="ri-download-line text-sm"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* 프로세스 단계 */}
              <div className="mb-4">
                <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                  <span>발주서</span>
                  <span>역발주</span>
                  <span>인보이스</span>
                  <span>결제</span>
                  <span>세금계산서</span>
                  <span>거래완료</span>
                </div>
                <div className="flex items-center gap-2">
                  {[1, 2, 3, 4, 5, 6].map((step) => (
                    <div key={step} className="flex-1 flex items-center">
                      <div className={`w-3 h-3 rounded-full ${
                        step <= (order.progress / 100 * 6) ? 'bg-blue-600' : 'bg-gray-300'
                      }`}></div>
                      {step < 6 && (
                        <div className={`flex-1 h-0.5 ${
                          step < (order.progress / 100 * 6) ? 'bg-blue-600' : 'bg-gray-300'
                        }`}></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* 액션 버튼 */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center gap-4">
                  <div className="text-sm text-gray-600">
                    발주일: {order.orderDate}
                  </div>
                  {order.invoiceNumber && (
                    <div className="text-sm text-gray-600">
                      인보이스: {order.invoiceNumber}
                    </div>
                  )}
                </div>
                
                <div className="flex items-center gap-2">
                  <button 
                    onClick={() => handleEditClick(order)}
                    className="text-blue-600 hover:text-blue-800 w-8 h-8 flex items-center justify-center"
                  >
                    <i className="ri-edit-line"></i>
                  </button>
                  <button className="text-green-600 hover:text-green-800 w-8 h-8 flex items-center justify-center">
                    <i className="ri-phone-line"></i>
                  </button>
                  <button className="text-gray-600 hover:text-gray-800 w-8 h-8 flex items-center justify-center">
                    <i className="ri-download-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 발주서 작성 모달 */}
      {addModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h2 className="text-xl font-bold text-gray-900">발주서 작성</h2>
              <button 
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedCustomer(null);
                  setSelectedVendor(null);
                }}
                className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-6 space-y-6">
              {/* 고객 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">고객 정보</h3>
                
                {/* 고객 선택 버튼 */}
                <div className="mb-4">
                  <button
                    onClick={() => setShowCustomerSelect(true)}
                    className="w-full px-4 py-3 border-2 border-dashed border-blue-300 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <i className="ri-user-search-line text-xl"></i>
                    <span className="font-medium">고객 검색 및 선택</span>
                  </button>
                </div>

                {/* 선택된 고객 정보 표시 */}
                {selectedCustomer && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <i className="ri-check-line text-blue-600"></i>
                        <span className="text-sm font-semibold text-blue-900">선택된 고객</span>
                      </div>
                      <button
                        onClick={() => setSelectedCustomer(null)}
                        className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                      >
                        선택 해제
                      </button>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div><span className="text-gray-600">고객명:</span> <span className="font-medium">{selectedCustomer.name}</span></div>
                      <div><span className="text-gray-600">연락처:</span> <span className="font-medium">{selectedCustomer.contact}</span></div>
                      <div><span className="text-gray-600">본식일:</span> <span className="font-medium">{selectedCustomer.weddingDate}</span></div>
                      <div><span className="text-gray-600">예식장:</span> <span className="font-medium">{selectedCustomer.venue}</span></div>
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">고객명</label>
                    <input 
                      type="text" 
                      value={selectedCustomer?.name || ''}
                      onChange={(e) => selectedCustomer && setSelectedCustomer({...selectedCustomer, name: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">연락처</label>
                    <input 
                      type="text" 
                      value={selectedCustomer?.contact || ''}
                      onChange={(e) => selectedCustomer && setSelectedCustomer({...selectedCustomer, contact: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">본식일</label>
                    <input 
                      type="date" 
                      value={selectedCustomer?.weddingDate || ''}
                      onChange={(e) => selectedCustomer && setSelectedCustomer({...selectedCustomer, weddingDate: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">예식장</label>
                    <input 
                      type="text" 
                      value={selectedCustomer?.venue || ''}
                      onChange={(e) => selectedCustomer && setSelectedCustomer({...selectedCustomer, venue: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* 업체 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">업체 정보</h3>
                
                {/* 업체 선택 버튼 */}
                <div className="mb-4">
                  <button
                    onClick={() => setShowVendorSelect(true)}
                    className="w-full px-4 py-3 border-2 border-dashed border-green-300 rounded-lg text-green-600 hover:bg-green-50 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <i className="ri-building-line text-xl"></i>
                    <span className="font-medium">업체 검색 및 선택</span>
                  </button>
                </div>

                {/* 선택된 업체 정보 표시 */}
                {selectedVendor && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <i className="ri-check-line text-green-600"></i>
                        <span className="text-sm font-semibold text-green-900">선택된 업체</span>
                      </div>
                      <button
                        onClick={() => setSelectedVendor(null)}
                        className="text-green-600 hover:text-green-800 text-sm cursor-pointer"
                      >
                        선택 해제
                      </button>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div><span className="text-gray-600">업체명:</span> <span className="font-medium">{selectedVendor.name}</span></div>
                      <div><span className="text-gray-600">담당자:</span> <span className="font-medium">{selectedVendor.manager}</span></div>
                      <div><span className="text-gray-600">연락처:</span> <span className="font-medium">{selectedVendor.contact}</span></div>
                      <div><span className="text-gray-600">수수료율:</span> <span className="font-medium">{selectedVendor.commissionRate}%</span></div>
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">업체명</label>
                    <input 
                      type="text" 
                      value={selectedVendor?.name || ''}
                      onChange={(e) => selectedVendor && setSelectedVendor({...selectedVendor, name: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">담당자</label>
                    <input 
                      type="text" 
                      value={selectedVendor?.managerName || ''}
                      onChange={(e) => selectedVendor && setSelectedVendor({...selectedVendor, managerName: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">업체 연락처</label>
                    <input 
                      type="text" 
                      value={selectedVendor?.contact || ''}
                      onChange={(e) => selectedVendor && setSelectedVendor({...selectedVendor, contact: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">서비스 유형</label>
                    <input
                      type="text"
                      value={selectedVendor?.subCategory || ''}
                      onChange={(e) => selectedVendor && setSelectedVendor({...selectedVendor, subCategory: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* 금액 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">금액 정보</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">계약금액</label>
                    <input 
                      type="text" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">수수료율</label>
                    <input 
                      type="text" 
                      placeholder="예: 15%"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">결제조건</label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8">
                      <option>계약금 50% + 잔금 50%</option>
                      <option>계약금 30% + 중도금 30% + 잔금 40%</option>
                      <option>일시불</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">납기일</label>
                    <input 
                      type="date" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* 파일 첨부 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">첨부파일</h3>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <i className="ri-upload-cloud-line text-2xl text-gray-400"></i>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">파일을 드래그하거나 클릭하여 업로드</p>
                  <p className="text-xs text-gray-500">PDF, JPG, PNG 파일 (최대 10MB)</p>
                  <input type="file" multiple className="hidden" />
                  <button className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm">
                    파일 선택
                  </button>
                </div>
              </div>

              {/* 서비스 범위 */}
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">서비스 범위</label>
                <textarea 
                  rows={4}
                  maxLength={500}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  placeholder="제공할 서비스의 상세 내용을 입력하세요 (최대 500자)"
                />
              </div>

              {/* 특이사항 */}
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">특이사항</label>
                <textarea 
                  rows={3}
                  maxLength={500}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  placeholder="특이사항을 입력하세요 (최대 500자)"
                />
              </div>
            </div>

            <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button 
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedCustomer(null);
                  setSelectedVendor(null);
                }}
                className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                취소
              </button>
              <button 
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                발주서 전송
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 고객 선택 모달 */}
      {showCustomerSelect && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="text-xl font-bold text-gray-900">고객 선택</h2>
                  <p className="text-sm text-gray-600 mt-1">등록된 고객 목록에서 선택하세요</p>
                </div>
                <button 
                  onClick={() => {
                    setShowCustomerSelect(false);
                    setCustomerSearchTerm('');
                  }}
                  className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              {/* 검색 입력 */}
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                <input
                  type="text"
                  placeholder="고객명 또는 연락처로 검색..."
                  value={customerSearchTerm}
                  onChange={(e) => setCustomerSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="p-6">
              <div className="space-y-3">
                {filteredCustomers.map((customer) => (
                  <div
                    key={customer.id}
                    onClick={() => handleCustomerSelect(customer)}
                    className="border border-gray-200 rounded-lg p-4 hover:border-blue-400 hover:bg-blue-50 transition-all cursor-pointer"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                          <i className="ri-user-line text-blue-600 text-xl"></i>
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <h3 className="font-semibold text-gray-900">{customer.name}</h3>
                          </div>
                          <div className="flex items-center gap-4 text-sm text-gray-600">
                            <div className="flex items-center gap-1">
                              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                              <span>{customer.contact}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                              <span>{customer.manager}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm text-gray-600 mb-1">본식일</div>
                        <div className="text-sm font-bold text-blue-600">{customer.weddingDate}</div>
                      </div>
                    </div>
                  </div>
                ))}
                
                {filteredCustomers.length === 0 && (
                  <div className="text-center py-12">
                    <i className="ri-user-line text-4xl text-gray-300 mb-4"></i>
                    <p className="text-gray-500">검색 결과가 없습니다.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 업체 선택 모달 */}
      {showVendorSelect && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="text-xl font-bold text-gray-900">업체 선택</h2>
                  <p className="text-sm text-gray-600 mt-1">등록된 업체 목록에서 선택하세요</p>
                  <p className="text-xs text-amber-700 mt-1">초대한 업체만 발주 가능합니다.</p>
                </div>
                <button 
                  onClick={() => {
                    setShowVendorSelect(false);
                    setVendorSearchTerm('');
                  }}
                  className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              {/* 검색 입력 */}
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                <input
                  type="text"
                  placeholder="업체명, 서비스 유형, 담당자로 검색..."
                  value={vendorSearchTerm}
                  onChange={(e) => setVendorSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="p-6">
              <div className="space-y-3">
                {filteredVendors.map((vendor) => (
                  <div
                    key={vendor.vendorIdx}
                    onClick={() => handleVendorSelect(vendor)}
                    className="border border-gray-200 rounded-lg p-4 hover:border-blue-400 hover:bg-blue-50 transition-all cursor-pointer"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                          <i className="ri-building-line text-blue-600 text-xl"></i>
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <h3 className="font-semibold text-gray-900">{vendor.name}</h3>
                            <span className="inline-flex px-2 py-0.5 text-xs font-medium rounded bg-purple-100 text-purple-700">
                              {vendor.subCategory}
                            </span>
                          </div>
                          <div className="flex items-center gap-4 text-sm text-gray-600">
                            <div className="flex items-center gap-1">
                              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                              <span>{vendor.manager}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                              <span>{vendor.contact}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                              <span>{vendor.email}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm text-gray-600 mb-1">수수료율</div>
                        <div className="text-lg font-bold text-purple-600">{vendor.commissionRate}%</div>
                      </div>
                    </div>
                  </div>
                ))}
                
                {filteredVendors.length === 0 && (
                  <div className="text-center py-12">
                    <i className="ri-building-line text-4xl text-gray-300 mb-4"></i>
                    <p className="text-gray-500">검색 결과가 없습니다.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 발주 수정 모달 */}
      {editModalOpen && selectedOrder && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            {/* 모달 헤더 */}
            <div className="sticky top-0 bg-white border-b border-gray-200 px-1 py-4 flex items-center justify-between">
              <h2 className="text-xl font-bold text-gray-900">발주 수정</h2>
              <button 
                onClick={() => setEditModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            {/* 모달 내용 */}
            <div className="p-6 space-y-6">
              {/* 고객 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">고객 정보</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">고객명</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.customer}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">연락처</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.phone}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">본식일</label>
                    <input 
                      type="date" 
                      defaultValue={selectedOrder.weddingDate}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">예식장</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.venue}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* 업체 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">업체 정보</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">업체명</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.vendor}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">담당자</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.manager}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">업체 연락처</label>
                    <input 
                      type="text" 
                      defaultValue="010-1234-5678"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">서비스 유형</label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8">
                      <option>스튜디오</option>
                      <option>드레스</option>
                      <option>메이크업</option>
                      <option>예복</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* 금액 정보 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">금액 정보</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">계약금액</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.amount}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">결제금액</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.paidAmount}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">수수료율</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.commission}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">결제방법</label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8">
                      <option>계좌이체</option>
                      <option>카드결제</option>
                      <option>법인결제</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* 진행 상태 */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">진행 상태</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">현재 단계</label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8">
                      <option>발주서</option>
                      <option>역발주</option>
                      <option>인보이스</option>
                      <option>결제</option>
                      <option>세금계산서</option>
                      <option>거래완료</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">발주일</label>
                    <input 
                      type="date" 
                      defaultValue={selectedOrder.orderDate}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm text-gray-600 mb-1">인보이스 번호</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.invoiceNumber}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm text-gray-600 mb-1">세금계산서 번호</label>
                    <input 
                      type="text" 
                      defaultValue={selectedOrder.taxInvoiceNumber}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>

              {/* 특이사항 */}
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">특이사항</label>
                <textarea 
                  rows={4}
                  defaultValue={selectedOrder.notes}
                  maxLength={500}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  placeholder="특이사항을 입력하세요 (최대 500자)"
                />
              </div>
            </div>

            {/* 모달 푸터 */}
            <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <button 
                onClick={() => setEditModalOpen(false)}
                className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap"
              >
                취소
              </button>
              <button 
                onClick={handleSaveEdit}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
              >
                저장
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 결제완료 확인 모달 */}
      {paymentModalOpen && selectedPaymentOrder && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
            <div className="p-6">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-green-600 text-3xl"></i>
              </div>
              
              <h2 className="text-xl font-bold text-gray-900 text-center mb-2">결제 완료 처리</h2>
              <p className="text-gray-600 text-center mb-6">
                해당 발주건의 결제를 완료 처리하시겠습니까?
              </p>

              <div className="bg-gray-50 rounded-lg p-4 mb-6 space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">발주번호</span>
                  <span className="font-semibold text-gray-900">{selectedPaymentOrder.id}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">고객명</span>
                  <span className="font-semibold text-gray-900">{selectedPaymentOrder.customer}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">업체명</span>
                  <span className="font-semibold text-gray-900">{selectedPaymentOrder.vendor}</span>
                </div>
                <div className="flex justify-between text-sm border-t border-gray-200 pt-2 mt-2">
                  <span className="text-gray-600">결제금액</span>
                  <span className="font-bold text-green-600 text-lg">{selectedPaymentOrder.amount}</span>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6">
                <div className="flex items-start gap-2">
                  <i className="ri-information-line text-blue-600 mt-0.5"></i>
                  <div className="text-sm text-blue-900">
                    <p className="font-medium mb-1">결제 완료 후 변경사항</p>
                    <ul className="text-xs space-y-1 text-blue-700">
                      <li>• 상태가 '결제'로 변경됩니다</li>
                      <li>• 결제금액이 계약금액과 동일하게 설정됩니다</li>
                      <li>• 다음 단계인 세금계산서 발행이 가능합니다</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setPaymentModalOpen(false);
                    setSelectedPaymentOrder(null);
                  }}
                  className="flex-1 px-4 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap cursor-pointer"
                >
                  취소
                </button>
                <button
                  onClick={handleConfirmPayment}
                  className="flex-1 px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-check-line mr-1"></i>
                  정산/송금 완료 처리
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderManagement;
